module.exports = __webpack_public_path__ + "img/icon-hearing-aid-support.e02b4033.svg";